<template>
  <form @submit.prevent="saveCart">
    <SfHeading :level="4" :title="$t('Shopping List')" class="sf-heading--left" />
    <SfSelect
      v-if="!isNewShoppingList"
      v-model="selectedShoppingList"
      name="selectedShoppingList"
      :label="$t('Shopping List')"
      :aria-label="$t('Shopping List')"
      :required="true"
    >
      <SfSelectOption v-for="option in shoppingList" :key="option.Id" :value="option.Id">
        {{ option.Name }}
      </SfSelectOption>
    </SfSelect>
    <SfInput
      v-else
      name="name"
      v-model="name"
      :required="true"
      :label="$t('Shopping List Name')"
      :aria-label="$t('Shopping List Name')"
    />
    <SfButton
      v-if="!!shoppingList.length"
      class="sf-button--text m-b-10"
      @click="isNewShoppingList = !isNewShoppingList"
      type="button"
    >
      {{ isNewShoppingList ? $t('Update Existing Shopping List') : $t('Create New Cart') }}
    </SfButton>
    <SfButton
      class="fz-input-button__button sf-button--outline sf-button--full-width"
      :disabled="isDidabled()"
      type="submit"
    >
      {{ $t('Save Cart') }}
    </SfButton>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  SfButton, SfInput, SfHeading, SfSelect,
} from '@storefront-ui/vue';

export default {
  name: 'SaveCart',
  components: {
    SfButton,
    SfInput,
    SfHeading,
    SfSelect,
  },
  data() {
    return {
      name: '',
      selectedShoppingList: '',
      isNewShoppingList: true,
    };
  },
  computed: {
    ...mapGetters({
      shoppingList: 'user/shoppingList',
    }),
  },
  methods: {
    isDidabled() {
      return this.isNewShoppingList ? !this.name : !this.selectedShoppingList;
    },
    async saveCart() {
      if (this.isDidabled()) return;
      if (this.isNewShoppingList) {
        await this.addShoppingList({ Name: this.name });
      } else {
        await this.updateShoppingList(this.selectedShoppingList);
      }

      this.$router.push('/my-account/shopping-list');
    },
    ...mapActions({
      addShoppingList: 'user/addShoppingList',
      updateShoppingList: 'user/updateShoppingList',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/helpers';
@import 'src/scss/_breakpoint';

.sf-heading {
  @include flexbox-desktop {
    margin-bottom: var(--spacer-sm);
  }
}

.sf-button--outline {
  --button-border-color: var(--_c-gray-secondary);
  --button-color: var(--_c-gray-secondary);
}
</style>
